import createVueComponent from '../createVueComponent';
var ChevronsDownUp = createVueComponent('ChevronsDownUpIcon', [['path', {
  d: 'm7 20 5-5 5 5'
}], ['path', {
  d: 'm7 4 5 5 5-5'
}]]);
export default ChevronsDownUp;